export default "__VITE_ASSET__ET_Pj_eM__"